import React from "react";

import { TextCenter } from "src/common/components/TextAlign";

import changeGif from "./change.gif";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>
			A verzióban kattinthatóvá tettük a Páciens áttekintő nézetén a nem
			elvégzett vizsgálatok részt is.
		</h1>
		<p>
			Egy hiányzó és a már meglévő vizsgálati eredményekre kattintva
			megjelenik az adott vizsgálat űrlapja, melyen az adatokat megadva új
			verzió vihető fel a rendszerbe.
		</p>
		<TextCenter>
			<img src={changeGif} width="90%" />
		</TextCenter>
	</section>
);
